var map = {
	"./2024_09_collaboration-with-private-donor-secured.md": 5229,
	"./2025_01_2024-clearcut-season-released.md": 9161,
	"./2025_04_planet-imagery-integration.md": 8218,
	"./2025_11_foresttrace-public-release.md": 896,
	"./2025_12_foresttrace-at-agu-2025.md": 1205,
	"./2026_06_forestry-ai-assistant-powered-by-groq.md": 5684
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3915;